import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  order: {},
  isAccessable: true,
  loaded: false,
  waitingForGeneration: false,
  needsPaymenRetry: false
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};